import { forwardRef, HTMLProps, Ref } from "react";

export type SelectProps = HTMLProps<HTMLSelectElement> & {
  inErrorState?: boolean;
};

export const Select = forwardRef(
  ({ inErrorState, className, children, ...props }: SelectProps, ref: Ref<HTMLSelectElement>) => {
    const baseClasses = "mt-1 h-10 w-full rounded border px-3 text-sm focus:outline-none";
    const errorClasses = inErrorState
      ? "bg-red-50 border-red-500 focus-visible:border-red-600"
      : "bg-gray-50 focus-visible:border-gray-400";

    return (
      <select
        ref={ref}
        className={`${baseClasses} ${errorClasses}${className ? ` ${className}` : ""}`}
        {...props}
      >
        {children}
      </select>
    );
  }
);
